module.exports = __webpack_public_path__ + "static/media/404.e645ee39.gif";